export const secretCodeAES =
  "0cdc66ca70a13aaec7959d52bfb7b502d9e55ac12a7b2446f61e52c44fee0040";
export const SITE_NAME = "Pradhan Mantri Bharatiya Janaushadhi Pariyojana";
export const SITE_DESC =
  "Pradhan Mantri Bharatiya Janaushadhi Pariyojana is a campaign–public welfare scheme of Government of India. It was launched by the Department of Pharmaceuticals to provide quality medicines at affordable prices to the masses through special kendras known as Pradhan Mantri Bharatiya Janaushadhi Pariyojana Kendra.";

export const SITE_LOGO_ICON = "./img/logo.svg";
export const SITE_SYMBOL = "./img/symbol.svg";

export const API_RESPONSE = {
  MESSAGE_503: "Please try again later, something went wrong!",
  MESSAGE_500: "Oops! There was an issue!",
  MESSAGE_INFO: "Sorry, we're unable to return at the moment",
};
export const FILE_UPLOAD = {
  MESSAGE_200: "File Uploaded Successfully",
};
export const FILE_SIZE = {
  MESSAGE: "File size should be 5MB or less than 5MB.",
};
export const ALL_FEILDS = {
  REQUIRED: "All fields marked with an asterisk (*) are required !",
  APPLICATION_FIELD_REQUIRED: "All fields marked with an asterisk (*) are required. Please ensure all necessary documents are uploaded!",
};

export const isLicenseBased = true;
